import type { TrackableItem } from '$lib/utils/stripe.utils';
import type { Context, Plugin } from '@segment/analytics-next';
import type { Context as NodeContext, Plugin as NodePlugin } from '@segment/analytics-node';

function hasLookupKey(key: string, products: Array<TrackableItem>): boolean {
	for (const product of products) {
		if (product.price_lookup_key === key) {
			return true;
		}
	}
	return false;
}

/**
 * Pin the revenue to $300 (approx. trial user LTV)
 */
export function createPinMetaTrialRevenuePlugin<
	PluginType extends Plugin | NodePlugin
>(): PluginType {
	return {
		name: 'Pin Meta Trial Revenue',
		type: 'enrichment',
		version: '1.0.0',
		isLoaded: () => true,
		load: () => Promise.resolve(),
		track: (ctx: PluginType extends Plugin ? Context : NodeContext) => {
			if (ctx.event.event === 'Trial Started') {
				let revenue = 300;

				if (JSON.parse(ctx.event.properties?.user_labels ?? '[]').includes('PARTNER_COMPOSTCREW')) {
					revenue = 468;
				} else if (
					hasLookupKey(
						'digital_bin_rental_rcity_farmbox_monthly',
						ctx.event.properties?.products ?? []
					)
				) {
					revenue = 400;
				} else if (
					hasLookupKey(
						'digital_bin_rental_rcity_farmbox_plus_monthly',
						ctx.event.properties?.products ?? []
					)
				) {
					revenue = 550;
				}

				ctx.updateEvent('properties.revenue', revenue);
			}
			return ctx;
		}
	} as unknown as PluginType;
}
